export class DataCatalogValidationIssue {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "severity",
            "baseName": "severity",
            "type": "DataCatalogIssueSeverity",
            "format": ""
        },
        {
            "name": "code",
            "baseName": "code",
            "type": "string",
            "format": ""
        },
        {
            "name": "message",
            "baseName": "message",
            "type": "string",
            "format": ""
        },
        {
            "name": "path",
            "baseName": "path",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataCatalogValidationIssue.attributeTypeMap;
    }
    constructor() {
    }
}
